import { useQuery } from "@tanstack/react-query";
import { getPartialRollsetsData } from "../repositories/PartialRollsetsRepository";

export const usePartialRollsets = () => {
	return useQuery({
		queryKey: ["partialRollsets"],
		queryFn: ({ signal }) => getPartialRollsetsData({ signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
